module.exports = __webpack_public_path__ + "static/media/0014.71c783e6.jpg";